"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight, Fingerprint, ChartLine, MonitorSmartphone, Trees } from "lucide-react";
import { cn } from "@/lib/utils";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.1,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) observer.unobserve(entry.target);
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const services = [{
  title: "Psychologische Praxis",
  subtitle: "Geist & Resilienz",
  description: "Individuelle Krisenberatung und psychologische Begleitung in einem geschützten Raum für Ihre persönliche Resilienz.",
  icon: Fingerprint,
  color: "text-[#7D5BA6]",
  border: "border-[#7D5BA6]/20",
  bg: "bg-[#7D5BA6]/5",
  link: "https://praxis-soonwald.de"
}, {
  title: "Organisationsberatung",
  subtitle: "Struktur & Führung",
  description: "Systemisches Coaching und strategische Beratung für gesunde Strukturen und resiliente Teams in Unternehmen.",
  icon: ChartLine,
  color: "text-[#4A6A8A]",
  border: "border-[#4A6A8A]/20",
  bg: "bg-[#4A6A8A]/5",
  link: "https://christ-coaching.de"
}, {
  title: "Tai Chi Schule",
  subtitle: "Körper & Balance",
  description: "Traditionelle Bewegungskunst zur Förderung von innerer Ruhe, Balance und körperlicher Vitalität im Soonwald.",
  icon: MonitorSmartphone,
  color: "text-[#C2B280]",
  border: "border-[#C2B280]/20",
  bg: "bg-[#C2B280]/5",
  link: "https://tai-chi-soonwald.de"
}, {
  title: "Wildnisschule",
  subtitle: "Natur & Erdung",
  description: "Naturverbundenheit und ursprüngliches Wissen als Kraftquelle für moderne Herausforderungen.",
  icon: Trees,
  color: "text-[#76A344]",
  border: "border-[#76A344]/20",
  bg: "bg-[#76A344]/5",
  link: "https://wildnisschule-soonwald.de"
}];
export default function StrategicSolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return;
}